import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {Breadcrumb} from 'shells/layout/page-title-breadcrumbs';

import {PageContainer} from '../../layout/page-container';
import {PageTitleBar} from '../../layout/page-title-bar';

import {IntegrationsPage} from './integrations-page';

type Props = ContextRouter & {
    breadcrumbs: Breadcrumb[];
    breadcrumbsTitle: string;
    content?: React.ReactNode;
    glossaryKey: string;
};

export function IntegrationsPageWrapper(props: Props) {
    const {breadcrumbs, breadcrumbsTitle, glossaryKey, ...rest} = props;

    return (
        <PageContainer
            title='Integrations'
            noPadding={true}
            whiteBackground={true}
            pageTitleBar={
                <PageTitleBar
                    title='Integrations'
                    subheaderPrimaryText='Integrate with your favorite tools' // This only shows if breadcrumbs are empty/broken
                    breadcrumbsTitle={breadcrumbsTitle}
                    breadcrumbs={breadcrumbs}
                    glossaryKey={glossaryKey}
                />
            }
        >
            <IntegrationsPage {...rest} />
        </PageContainer>
    );
}
